<template>
    <section class="live-share-wrapper"
		:style="{ 'visibility': visible ? 'visible' : 'hidden' }">
        <div class="live-share">
            <img :src="image"
                id="canvas-image"
				:class="{ 'small': rotate }"
                v-if="image" />
            <div class="live-share-image"
				:class="{ 'small': rotate }">
                <img :src="`data:image/png;base64,${ poster }`" />
                <!-- <img :src="poster" /> -->
                <div class="live-share-image-user">
                    <img :src="`data:image/png;base64,${ userImage }`" />
                    <!-- <img :src="userImage" /> -->
                    {{ userName }}
                </div>
            </div>
            <p>长按保存图片，分享至朋友圈完成打卡</p>
			<div class="live-share-close-rotate"
				v-if="rotate"
				@click="handleClose"></div>
        </div>
        <div class="live-share-close"
			v-if="!rotate"
            @click="handleClose"></div>
    </section>
</template>

<script>
	/** eslint-disable */
	import html2canvas from 'html2canvas'

	export default {
		name: 'LiveShare',
		props: {
			/**
			 * 展示的分享图url
			 */
			poster: {
				type: String
			},
			/**
			 * 用户头像
			 */
			userImage: {
				type: String
			},
			/**
			 * 用户昵称
			 */
			userName: {
				type: String
			},
			/**
			 * 是否横屏
			 */
			rotate: {
				type: Boolean,
				default: false
			},
			/**
			 * 是否展示
			 */
			visible: Boolean
		},
		data() {
			return {
				image: '' // canvas绘制后的图片
			}
		},
		mounted() {
			this.drawImage()
		},
		methods: {
			drawImage() {
				const el = this.$el.querySelector('.live-share-image')

				// 等图片全部绘制完成后再加载弹框
				let promiseList = []
				const imgs = el.querySelectorAll('img')
				for (let i = 0; i < imgs.length; i++) {
					const p = new Promise(resolve => {
						imgs[i].onload = () => resolve()
					})
					promiseList.push(p)
				}
				Promise.all(promiseList).then(() => {
					html2canvas(el, {
						backgroundColor: null,
						logging: false,
						useCORS: true,
						scale: 4
					}).then(canvas => {
						this.image = canvas.toDataURL('image/jpeg')

						this.$nextTick(() => {
							const canvasImage = this.$el.querySelector('#canvas-image')
							canvasImage.style.width = `${ el.offsetWidth }px`
						})
						// this.isShareVisible = true
					})
				})
			},
			handleClose () {
				this.$emit('close')
			}
		}
	}
</script>

<style lang="scss" scoped>
    @import '../style/main';

    .live-share-wrapper {
        -webkit-touch-callout: none;
		user-select: none;
		transform: translateZ(1px);
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
		left: 0;
		z-index: 99999999;
        background-color: rgba(#000, .6);
    }

    .live-share {
        -webkit-touch-callout: none;
		user-select: none;
        transform: translateX(-50%);
        position: absolute;
        top: rem(50);
        left: 50%;
		z-index: 99999999;
        padding: rem(20) rem(20) rem(30);
        width: rem(500);
        background-color: #fff;
        font-size: rem(28);
        font-weight: bold;
        color: #36312f;

        #live-share-canvas {
            position: absolute;
            visibility: hidden;
        }

		$smallImageHeight: rem(550);

        #canvas-image {
            position: absolute;
            // width: 100%;
            height: rem(800);
            z-index: 99999999;

			&.small {
				height: $smallImageHeight;
			}
        }

        &-image {
            position: relative;
            height: rem(800);

			&.small {
				height: $smallImageHeight;
			}

            & > img {
                width: 100%;
                height: 100%;
            }

            &-user {
                $iconSize: rem(50);
                $offset: rem(30);

                position: absolute;
                bottom: $offset;
                left: $offset;
                font-size: rem(24);
                color: #fff;

                img {
                    vertical-align: middle;
                    margin-right: $offset / 4;
                    width: $iconSize;
                    height: $iconSize;
                    border-radius: 50%;
                }
            }
        }

        & > p {
            margin-top: rem(30);
            text-align: center;
        }
    }

    .live-share-close {
        $size: rem(80);
        transform: translateX(-50%);
        position: absolute;
        top: rem(1000);
        // bottom: rem(120);
        left: 50%;
        width: $size;
        height: $size;
        background-image: url('../assets/images/live-share-close.png');
        background-size: contain;

		&-rotate {
			$size: rem(50);
			width: $size;
			height: $size;
			position: absolute;
			top: -$size / 2;
			right: -$size / 2;
			background: {
				image: url('../assets/images/live-icon-rotate-close.png');
				size: contain;
			}
		}
    }
</style>
